module.exports = __webpack_public_path__ + "04e5161b81fb94527543cb633a9a826f.svg";